module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8r3r6n-a77af3a1f5a06d3126abc9e694b4bc25.svg";